module.exports = __webpack_public_path__ + "media/images/common/logo_bg_08-a576fd43aa59ff03cfaf0dfc53f066ce.png";